<template>
  <div class="footer">

  </div>
</template>


<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  height: 150px;
  background: #90999c;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue